import React, { Fragment, useEffect, useState } from 'react'
import { getRequest } from '../../globalhelper/helper'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import moment from 'moment'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { useDispatch } from 'react-redux'
import { hideLoader, showAlert, showLoader } from '../../redux/Common/commonActions'
import { CSVLink } from 'react-csv'

const PeriodCostSheetReport = () => {
  const [tableData, setTableData] = useState([])
  const [companies, setCompanies] = useState([])

  const [formData, setFormData] = useState({
    company: '',
    fromDate: '',
    toDate: ''
  })

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(({ res }) => {
      setCompanies(
        (res.data || []).sort((a, b) =>
          (a.orgname || "").localeCompare(b.orgname || "")
        )
      );
      if (res.data && res.data.length === 1) {
        setFormData((prev) => ({ ...prev, company: res.data[0] }));
      }
      var currentDate = moment()
      var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
      var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
      setFormData(prev => {
        return { ...prev, fromDate: firstDay, toDate: lastDay }
      })
    }).catch((err) => console.log(err));
  }, [])

  const handleChange = (name, value) => {
    setFormData(prev => {
      return { ...prev, [name]: value }
    })
  }

  let dispatch = useDispatch()

  const handleReset = () => {
    setFormData({
      fromDate: '',
      toDate: '',
      company: ''
    })
    setTableData([])
  }

  const handleSubmit = () => {
    dispatch(showLoader())

    getRequest(
      `api/edureka/getPeriodCostSheetReport?fromDate=${formData.fromDate}&toDate=${formData.toDate}&company=${formData.company.orgid}`
    )
      .then(response => {
        const responseData = JSON.parse(response.res.data)
        if (responseData.length) {
          setTableData(responseData)
        } else {
          dispatch(
            showAlert(
              'No data found, please try some other combination',
              'error'
            )
          )
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        dispatch(hideLoader())
      })
  }

  return (
    <Fragment>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant='h6'>
            Please select the date range to view Reports
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size="small"
                fullWidth
                value={formData.company || null}
                options={companies || []}
                getOptionLabel={(option) => option?.orgname || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.orgname === value?.orgname
                }
                onChange={(event, newValue) => handleChange("company", newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Company Name"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdFrom'
                  value={formData.fromDate}
                  views={['day', 'month', 'year']}
                  onChange={newValue => {
                    handleChange('fromDate', newValue.format('YYYY-MM-DD'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdTo'
                  value={formData.toDate}
                  views={['day', 'month', 'year']}
                  onChange={newValue => {
                    handleChange('toDate', newValue.format('YYYY-MM-DD'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={3}>
              <Button
                color='primary'
                variant='contained'
                onClick={handleSubmit}
                disabled={
                  !formData.fromDate || !formData.toDate || !formData.company
                }
              >
                Submit
              </Button>
              <Button
                color='error'
                onClick={handleReset}
                style={{ marginLeft: '10px' }}
                variant='contained'
              >
                Reset
              </Button>
              {tableData.length ? (
                <CSVLink
                  data={tableData}
                  filename='Bill Analysis and Status Report.csv'
                  style={{ marginLeft: '10px' }}
                >
                  <Button color='success' variant='contained'>
                    Download
                  </Button>
                </CSVLink>
              ) : null}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {tableData.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {Object.keys(tableData[0]).map((item, index) => {
                  return <TableCell key={index}>{item}</TableCell>
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((item, index) => {
                return (
                  <TableRow key={index}>
                    {Object.keys(item).map((val, i) => {
                      return <TableCell key={i}>{item[val]}</TableCell>
                    })}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <ToastContainer />
    </Fragment>
  )
}

export default PeriodCostSheetReport
